module.exports = __webpack_public_path__ + "fonts/Lato-Hairline.ada4458b.woff2";